import { apiFetch } from "./apiClient";

export async function postDeviceTelemetry(telemetryData) {
  try {
    const res = await apiFetch("/api/testing/telemetry", {
      method: "POST",
      body: JSON.stringify(telemetryData),
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      return {
        error:
          errorData.error || `Failed to post device telemetry (${res.status})`,
      };
    }
    return res.json();
  } catch (error) {
    console.error("Error posting device telemetry:", error);
    return { error: error.message || "Failed to post device telemetry" };
  }
}

export async function getConnectionStatus() {
  try {
    const res = await apiFetch("/api/debug/cached-devices");
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      return {
        success: false,
        error:
          errorData.error ||
          `Failed to fetch cached device connection status (${res.status})`,
      };
    }
    const data = await res.json();
    return { success: true, data };
  } catch (error) {
    console.error("Error fetching cached device connection status:", error);
    return {
      success: false,
      error: error.message || "Failed to fetch cached device connection status",
    };
  }
}
